// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"2d8518ca","171":"14e13b03","453":"7e513c49"}[chunkId] + ".chunk.js";
};